export const COLLECTION = "characters";
export const COLLECTION_DISPLAY_NAME = "Character";
